function add_recipe_row() {
    var $container = $('.recipe-container');
    var $cloneable = $container.find('.cloneable');

    //Clone cloneable measurement row and append to container
    var $row = $cloneable.clone();
    $row.removeClass('cloneable').addClass('visible');
    $row.find('input[disabled], select[disabled]').removeAttr('disabled');
    $row.find('.no-touchy').removeClass('no-touchy');

    $row.appendTo($container);

    $('.recipe-hint').hide();

    init_selects();

    return $row;
}

$(function() {

    $body.on('click', '#add-recipe-row', function(e) {
        e.preventDefault();
        add_recipe_row();
    });

    $body.on('click', '#add-recipe-row-5', function(e) {
        e.preventDefault();

        for(var i = 0; i < 5; i++) {
            add_recipe_row();
        }
    });

    //Change recipe selected on Menu form
    $('#edit-menu-form').on('change', 'select[name="recipe_id_select[]"]', function(e) {
        var $row = $(this).closest('.row');

        //Set data
        var recipe_id = $(this).val();
        var selling_price = $(this).find('option:selected').attr('data-selling-price');
        var gross_profit = $(this).find('option:selected').attr('data-gross-profit');
        var profit_amount = $(this).find('option:selected').attr('data-profit-amount');
        var $recipe_unit = $row.find('select[name="recipe_unit[]"]');

        //Set id to hidden field
        $row.find('input[name="recipe_id[]"]').val(recipe_id);

        //Get units for selected recipe
        get_units_for_recipe(recipe_id, function(resp) {

            //If successful...
            if(resp.response) {

                //Replace the unit select with our new one
                $recipe_unit.parent().html(resp.content);

            } else {
                alert(resp.message);
            }

            //Need to reinit selects when the select is updated
            init_selects();

        });

        //Update column info
        $row.find('.mr-selling-price').html("(" + selling_price + ")");
        $row.find('.mr-gross-profit').html("(" + gross_profit + ")");
        $row.find('.mr-profit-amount').html("(" + profit_amount + ")");

    });

    //Change recipe quantity/unit on menu form
    $('#edit-menu-form').on('change', 'select[name="recipe_id_select[]"], input[name="recipe_quantity[]"], select[name="recipe_unit[]"]', function(e) {
        var $row = $(this).closest('.menu-recipe-row');
        var $recipes = $row.find('select[name="recipe_id_select[]"] option');
        var $units = $row.find('select[name="recipe_unit[]"] option');
        var $selected_recipe = [];
        var $selected_unit = [];

        //Get selected ingredient
        $.each($recipes, function(i, v) {
            if($(this).prop('selected')) {
                $selected_recipe = $(this);
            }
        });

        //Get selected units
        $.each($units, function(i, v) {
            if($(this).prop('selected')) {
                $selected_unit = $(this);
            }
        });

        //If we have selected a recipe...
        if($selected_recipe.length > 0) {

            var source_quantity = $selected_recipe.data('quantity');
            var source_unit = $selected_recipe.data('unit');
            var source_price = $selected_recipe.data('price');
            var $target_quantity = $row.find('input[name="recipe_quantity[]"]');
            var target_quantity = $target_quantity.val();

            //Convert any "custom" unit metrics into their proper values for calcing
            var custom_quantity = $selected_unit.data('custom-quantity') ? parseFloat($selected_unit.data('custom-quantity')) : 1;
            var new_quantity = (parseFloat($selected_unit.data('quantity')) * parseFloat(target_quantity)) / custom_quantity;
            var new_unit = $selected_unit.data('unit');

            var $price = $row.find('.recipe-price');

            //Ensure all needed fields are here before calculating price
            if(source_quantity && source_unit && source_price && Number.isFinite(new_quantity) && new_unit) {

                //Set loading on price
                $price.html("...");

                //Get price for recipe
                ajax_call('get', '/admin/get_price/' + source_quantity + '/' + source_unit + '/' + new_quantity + '/' + new_unit + '/' + source_price, {}, function(resp) {

                    //If successful...
                    if(resp.response) {

                        //Replace the wastage select with our new one
                        $price.html(resp.content);

                    } else {
                        alert(resp.message);
                    }
                });
            } else {
                console.log('At least one value missing - cannot calc price.');
            }

        }

    });


});
